import { render, staticRenderFns } from "./ListCourses.vue?vue&type=template&id=f8cd5e48&scoped=true&"
import script from "./ListCourses.vue?vue&type=script&lang=js&"
export * from "./ListCourses.vue?vue&type=script&lang=js&"
import style0 from "./ListCourses.vue?vue&type=style&index=0&id=f8cd5e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cd5e48",
  null
  
)

export default component.exports